import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WebRtcService {

  constructor( private _http: HttpClient) { }


  getICEServers(): Observable<any> {
    let headers = new HttpHeaders()
      .set('Content-Type', 'text/html')
      .set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7')
      .set('Accept-Language', 'en-US,en;q=0.9')
  
    return this._http.get<any>('http://stream.adr.avileap.com:8889/main/1037069/', { headers: headers })
      .pipe(
        catchError((error) => {
          console.error('Error fetching ICE servers:', error);
          throw error; // Re-throw the error to propagate it to the component
        })
      );
  }
  
}
